/** Route examples: IST-PAR, ALA-NQZ-ALA */
export function parseRouteEndpoints(route: string): {
  dep: string;
  arr: string;
} {
  const parts = route.split('-').filter(Boolean);
  if (parts.length >= 3) {
    return { dep: parts[0] ?? '', arr: parts[1] ?? '' };
  }
  if (parts.length === 2) {
    return { dep: parts[0] ?? '', arr: parts[1] ?? '' };
  }
  return { dep: '', arr: '' };
}
